import script from "./Feedback.vue?vue&type=script&setup=true&lang=ts"
export * from "./Feedback.vue?vue&type=script&setup=true&lang=ts"

import "./Feedback.vue?vue&type=style&index=0&id=2118ae05&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2118ae05"]])

export default __exports__